import React from 'react';
import '../Details.css';
import Navbar from '../navbar';
import UsersManager from './UsersManager';

function Users() {
  const pageTitle = "Users";

  return (
    <div className="details-container-page">
      <Navbar pageTitle={pageTitle} onToggleSidebar={true} />
      <div id="users-manager">
        <UsersManager />
      </div>
    </div>
  );
}

export default Users;
